<template>
  <div id="fortalezas">
    <section class="container is-fluid">
      <h2 class="half-top-section">Nuestras fortalezas /</h2>
      <strengths />
    </section>
    <section id="trabajo" class="container is-fluid mb-1">
      <h2 class="mb-1 top-section">Nuestro trabajo /</h2>
      <work />
    </section>
  </div>
</template>

<script>
import Strengths from "@/components/Strengths";
import Work from "@/components/Work";

export default {
  name: "Strength",
  components: { Strengths, Work }
};
</script>
